export enum IbanLocator {
    MASTER = 'MASTER',
    GENERATE = 'GENERATE',
    CUSTOM = 'CUSTOM'
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/account.const.ts